
export const parseNavigationInfo = (url: string): any =>
{
    const [path] = url.split("?");
    return { path: path, queryParams: parseQueryParams(url) };
};

export const parseQueryParams = (url: string): any =>
{
    const paramsStrIndex = url.indexOf("?");

    if (paramsStrIndex === -1)
    {
        return {};
    }

    return url
        .slice(paramsStrIndex + 1)
        .split("&")
        .reduce((acc, currValue) =>
        {
            const [prop, value] = currValue.split("=");

            acc[prop] = value;

            return acc;
        }, {});
};

export const getCurrentUrlQueryParams = (): any =>
{
    const currentUrl = window.location.href;
    return parseQueryParams(currentUrl);
};

export function getQueryParameterValue(parameterName: string): string
{
    const vars = window.location.search.substring(1).split("&");
    for (let i = 0; i < vars.length; i++)
    {
        const pair = vars[i].split("=");
        if (pair[0] === parameterName)
        {
            return pair[1];
        }
    }

    return "";
}


/**
 * Converts milliseconds to seconds.
 * @param {number} v - The value to convert from milliseconds to seconds.
 * @param {boolean} round - Flag indicating if the result should be rounded, i.e., no decimals.
 * @return {number}
 */
export const msToSeconds = (v: number, round: boolean = false): number =>
{
    const result: number = v / 1000;
    return round ? Math.floor(result) : result;
};

/**
 * Converts seconds to milliseconds.
 * @param v
 * @returns {number}
 */
export const secondsToMs = (v): number =>
{
    return Math.floor(v * 1000);
};

/**
 * Attempts to convert a string value or "true" to a boolean true.
 * Or attempts to convert a string value or "false" to a boolean false.
 * Or simply returns the original string.
 *
 * @param {string} setting
 * @returns {boolean | string}
 */
export const convertToBoolOrString = (setting: string): boolean | string =>
{
    if (setting.toLowerCase() === "true")
    {
        return true;
    }
    else if (setting.toLowerCase() === "false")
    {
        return false;
    }
    return setting;
};

/**
 * Generates UUIDs.
 * @returns {string}
 */
export const generateUUID = (): string =>
{
    let d: number = new Date().getTime();
    const uuid: string = "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (c)
    {
        let r = (d + Math.random() * 16) % 16 | 0;
        d = Math.floor(d / 16);
        return (c == "x" ? r : (r & 0x3 | 0x8)).toString(16);
    });
    return uuid;
};


export const createFormData = (object: Object, form?: FormData, namespace?: string): FormData =>
{
    const formData = form || new FormData();
    for (let property in object)
    {
        if (!object.hasOwnProperty(property) || !object[property])
        {
            continue;
        }
        const formKey = namespace ? `${namespace}[${property}]` : property;

        if (object[property] instanceof Date)
        {
            // Use local datetime format to avoid timezone shifts
            const date = object[property] as Date;
            const yyyy = date.getFullYear();
            const mm = String(date.getMonth() + 1).padStart(2, '0');
            const dd = String(date.getDate()).padStart(2, '0');
            const hh = String(date.getHours()).padStart(2, '0');
            const min = String(date.getMinutes()).padStart(2, '0');
            const ss = String(date.getSeconds()).padStart(2, '0');
            formData.append(formKey, `${yyyy}-${mm}-${dd}T${hh}:${min}:${ss}`);
        }
        else if (object[property] instanceof File)
        {
            // Handle File objects directly
            formData.append(formKey, object[property]);
        }
        else if (Array.isArray(object[property]))
        {
            // Handle arrays (including arrays of files)
            object[property].forEach((item: any, index: number) =>
            {
                if (item instanceof File)
                {
                    // For file arrays, use the property name directly to maintain compatibility
                    formData.append(property, item);
                }
                else if (typeof item === 'object' && item !== null)
                {
                    createFormData(item, formData, `${formKey}[${index}]`);
                }
                else
                {
                    formData.append(`${formKey}[${index}]`, item);
                }
            });
        }
        else if (typeof object[property] === 'object' && object[property] !== null)
        {
            createFormData(object[property], formData, formKey);
        }
        else
        {
            formData.append(formKey, object[property]);
        }
    }
    return formData;
};